import {mdiEye, mdiEyeOff} from "@mdi/js";
import _ from "lodash";

export const lang = document.querySelector('html').getAttribute('lang');

/**
 * Ширины диалогов для модальных окон
 * @type {number}
 */
let win_with_data=550;
if (document.body.offsetWidth < 560){
    win_with_data=320
}
export let win_with=win_with_data;
/**
 * Рест запрос типа GET
 * @param request
 * @param schema
 * @param id
 * @param client
 * @returns {*}
 */
export function GET(request, schema="public", id=false){
    return jqueryts.ajax().headers({
        "Accept-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).get(`/${lang}/api/${request}`).then(res=>{
        res = res.json()
        if (id){
            res.map(obj => {
                obj.id=obj[id]
                return obj
            });
        }
        return res
    })
}


/**
 * Рест запрос типа хранимых процедур
 * @param request
 * @param data
 * @param schema
 * @param id
 * @returns {*}
 */
export function POSTR(request, data, schema="public", id=false){
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).post(`/${lang}/api/rpc/${request}`, data).then(res=>{
        res = res.json()
        if (id){
            res.map(obj => {
                obj.id=obj[id]
                return obj
            });
        }
        return res
    })
}


export function POST(request, data, schema="public", id=false){
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "Prefer": "return=representation",
        "X-Custom-Ajax": `true`
    }).post(`/${lang}/api/${request}`, data).then(res=>{
        res = res.json()
        if (id){
            res.map(obj => {
                obj.id=obj[id]
                return obj
            });
        }
        return res
    })
}
/**
 * Рест запрос типа PUT
 * @param request
 * @param data
 * @param schema
 * @returns {*}
 */
export function PUT(request, data, schema="public" ){
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).put(`/${lang}/api/${request}`, data).then(res=>{
        res = res.json()
        return res
    })
}

/**
 * Рест запрос типа PATCH
 * @param request
 * @param data
 * @param schema
 * @returns {*}
 */
export function PATCH(request, data, schema="public" ){
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).patch(`/${lang}/api/${request}`, data).then(res=>{
        res = res.json()
        return res
    })
}

/**
 * Рест запрос типа DELETE
 * @param request
 * @param schema
 * @returns {*}
 */
export function DELETE(request, schema="public" ){
        return jqueryts.ajax().headers({
            "Content-Profile": `${schema}`,
            "X-Custom-Ajax": `true`
        }).del(`/${lang}/api/${request}`).then(res=>{
            res = res.json()
            return res
        })
    }


/**
 * Запрос типа POST для функций PHP
 * @param request
 * @param data
 * @returns {*}
 */
export function POSTP(request, data){
    return jqueryts.ajax()
        .headers({
            "X-Custom-Ajax": `true`
        }).post(
        `/${lang}/${request}/`, data).then(res=>{
        res = res.json()
        return res
    })
}


/**
 * Запрос типа GET для функций PHP
 * @param request
  * @returns {*}
 */
export function GETP(request){
    return jqueryts.ajax()
        .headers({
            "X-Custom-Ajax": `true`
        }).get(`/${lang}/${request}`).then(res=>{
        res = res.json()
        return res
    })
}


/**
 * Имитация клика, для перехода по ссылке
 * @param url
 */
export function openLinkInNewTab(url) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.addEventListener('click', () => {
        link.remove();
    });
    link.click();
}


const icon_eye = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#ccc" d="${mdiEye}"/></svg>`
const icon_eye_off = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#ccc" d="${mdiEyeOff}"/></svg>`


export function see_passw(input, label, top){
    try {

        if ($$(input).config.type === 'password') {
            $$(input).define('type', 'text');
            $$(input).refresh();
            $$(label).define('value', icon_eye_off);
            $$(label).refresh();
            toggleButtonPassw(input, label, false, top)
        } else {
            $$(input).define('type', 'password');
            $$(input).refresh();
            $$(label).define('value', icon_eye);
            $$(label).refresh();
            toggleButtonPassw(input, label, true, top)
        }
        init_blur_reg($$(input).getNode())

    } catch (e) {
        console.error(e)
    }
}


export function toggleButtonPassw(input, label, view=true, top="v-icon-hint-md"){
    try {

        const config={
            container:  $$(input).getNode(),
            view: "button",
            value: `${(view)?icon_eye_off:icon_eye}`,
            id: label,
            css: top,
            width: 40,
            height: 40,
            inputWidth: 40,
            click: function () {
                see_passw(input, label, top)
            }
        }
        jqueryts.ui(config);
    } catch (e) {
        console.error(e)
    }

}


export function init_blur_reg(label) {
    try {
        $(label).find("input").on('focus', function () {
            $(this).parent().parent().addClass("focus")
        })
        $(label).find("input").on('blur', function () {
            if ($(this).val().trim(" ") === "")
                $(this).parent().parent().removeClass("focus")
        })
    } catch (e){
        console.error(e)
    }
}

export function route_parse(){
    return window.location.pathname.split("/")
}



export function _t(index, debug=false) {
    const el=window.translate.getItem(index)
    if (debug){
        console.log(el, window.translate.serialize())
    }
    if (el===undefined) return index
    return el[lang]
}


export function onloadCapatcha(id) {
    if (window.smartCaptcha) {
        const container = document.getElementById(id);
        const widgetId = window.smartCaptcha.render(container, {
            sitekey: window.config.captcha.sitekey,
            hl: (lang==='ru')?'ru':'en',
        });
    }
}



export const treeBuild = (list, id, pid, debug = false) => {
    try {
        var map = {}, node, roots = [], i;
        for (i = 0; i < list.length; i += 1) {
            map[list[i][id]] = i; // initialize the map
            list[i].data = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
            node = list[i];
                if (node[pid] !== null) {
                    let level = node[pid]
                    if (node[pid] === node[id]) level = node[id]
                    if (level === null) level = 0
                    if (debug) {
                        try {
                            // console.log(level)
                            list[map[level]].data.push(node);
                        } catch (e) {
                            console.log(e)
                        }
                    } else {
                        // console.log(map[level], map[level], list[map[level]])
                        list[map[level]].data.push(node);
                    }

                } else {
                    roots.push(node);
                }
        }
        return roots;
    } catch (err) {
        console.error(err)
    }
}


/**
 * создание id
 * @param list
 * @param id
 * @param debug
 * @returns {(*&{id: *})[]}
 */
export const ids = (list, id, debug = false) => {
    const newList = _.map(list, obj => {
        return {...obj, id: obj[id]};
    });
    return newList
}


/**
 * Вернет строку с форматно выведенным размером в удобной для чтения форме
 * @param bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function mdi(icon, color='#ccc'){
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="${color}" d="${icon}"/></svg>`
}

